const initialState = {
    configSets: [],
    loading: false,
    error: null,
};

const mappingOverview = (state = initialState, action) => {
    switch (action.type) {
        case "FETCH_MAPPING_OVERVIEW_REQUEST":
            return { ...state, loading: true, error: null };
        case "FETCH_MAPPING_OVERVIEW_SUCCESS":
            return { ...state, loading: false, configSets: action.payload || [] };
        case "FETCH_MAPPING_OVERVIEW_FAILURE":
            return { ...state, loading: false, error: action.error };
        default:
            return state;
    }
};

export default mappingOverview;
